module.exports = __webpack_public_path__ + "46168ff58a55916a9f7beac4876d375c.pdf";